import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Chapter from "./pages/Chapter";
import MockTest from "./pages/MockTest";
import Subscribe from "./pages/Subscribe";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import Owner from "./pages/Owner";
import Privacy from "./pages/Privacy";
import DataDeletion from "./pages/DataDeletion";
import Protected from "./components/Protected";
import RouteEffects from "./components/RouteEffects";
import { registerServiceWorker } from "./lib/pwa";

registerServiceWorker();

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <RouteEffects />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Protected><Dashboard/></Protected>} />
            <Route path="/chapter/:cls/:subject/:chapterId" element={<Protected><Chapter/></Protected>} />
            <Route path="/mock-test/:cls/:subject" element={<Protected><MockTest/></Protected>} />
            <Route path="/subscribe" element={<Protected><Subscribe/></Protected>} />
            <Route path="/subscription/success" element={<Protected><SubscriptionSuccess/></Protected>} />
            <Route path="/owner" element={<Protected requireOwner><Owner/></Protected>} />
            <Route path="/privacy" element={<Privacy/>} />
            <Route path="/data-deletion" element={<DataDeletion/>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
